const translations = {
    rolesFieldPlaceholder: 'Roles'
};

export default translations;
